/* ==========================================================================
   تقييم العملاء — عبر النظام كله
   ========================================================================== */

/**
 * سياقات التقييم.
 *
 * لكل سياقٍ موضعُ زرّه وقائمةُ عناصره في الإعدادات: ما يُسأل عنه العميل
 * بعد مكالمةٍ غيرُ ما يُسأل عنه عند تسليم مشروع. والمكالمات لها جدولها
 * الخاص تاريخيًّا، والبقية في جدولٍ عام — والصفحة العامة واحدة.
 */
/* CONTRACT باقٍ في النوع لصفوفٍ قديمة قد تحمله — ولا يُعرض ولا يولَّد له رابط. */
export const RATING_KINDS = ['CALL', 'ACCOUNT', 'DEAL', 'CONTRACT', 'PROJECT', 'TASK'] as const;
export type RatingKind = (typeof RATING_KINDS)[number];

/** ما يولَّد له رابط من المسار العام الموحّد — كل السياقات عدا المكالمات. */
export const CLIENT_RATING_KINDS = ['ACCOUNT', 'DEAL', 'PROJECT', 'TASK'] as const;
export type ClientRatingKind = (typeof CLIENT_RATING_KINDS)[number];

export interface RatingKindDef {
  key: RatingKind;
  label: string;
  /** أين يظهر زرّ الطلب — للإعدادات كي يفهم الضابط أثر قائمته. */
  hint: string;
}

export const RATING_KIND_DEFS: readonly RatingKindDef[] = [
  { key: 'CALL', label: 'المكالمات', hint: 'رابطٌ يُنسخ من مركز الاتصال بعد المكالمة' },
  { key: 'ACCOUNT', label: 'خدمة العملاء', hint: 'تقييمٌ عام لتجربة العميل — من ملف العميل' },
  {
    key: 'DEAL',
    label: 'الصفقات',
    hint: 'من ملف الصفقة كسبًا أو خسارة — والسبب مطلوبٌ لنعرف لماذا',
  },
  { key: 'PROJECT', label: 'المشاريع', hint: 'تقييمٌ عام للمشروع — من نظرته العامة' },
  { key: 'TASK', label: 'مهام المشاريع', hint: 'لكل مهمةٍ رئيسية أو فرعية — من لوح المهمة' },
];

export const RATING_KIND_MAP = Object.fromEntries(
  RATING_KIND_DEFS.map((d) => [d.key, d]),
) as Readonly<Record<RatingKind, RatingKindDef>>;

/** عنصر تقييم مضبوط — يظهر صفًّا بنجومه في الصفحة العامة. */
export interface RatingItem {
  id: string;
  label: string;
}

/** ما تعرضه الصفحة العامة قبل الإرسال. */
export interface PublicRatingInfo {
  company: string;
  kind: RatingKind;
  /** سياقٌ يطمئن العميل أنه يقيّم الشيء الصحيح — عنوان العقد أو اسم المشروع. */
  title: string | null;
  when: string;
  submitted: boolean;
  items: RatingItem[];
}
